"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export default function useIsTouchDevice() {
  const $ = _c(2);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const globalScope = globalThis as typeof globalThis & {
        window?: Window | undefined;
        navigator?: Navigator | undefined;
      };
      const browserWindow = globalScope.window;
      const browserNavigator = globalScope.navigator;
      const isTouch = !!browserWindow && ("ontouchstart" in browserWindow || (browserNavigator?.maxTouchPoints ?? 0) > 0 || browserWindow.matchMedia?.("(pointer: coarse)")?.matches);
      setIsTouchDevice(isTouch);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isTouchDevice;
}